import PropTypes from 'prop-types'
import BaseButton from "./Button.jsx"

export default function PrimaryButton({children, ...props}) {
  return (
    <BaseButton color={"primary"} {...props}>
      {children}
    </BaseButton>
  )
}

PrimaryButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string,
  type: PropTypes.string
}